import type {
  ComparisonDetail,
  ProductPagePayload,
  RivalListItem,
  RoundListItem,
} from "../../../shared/contracts/product-pages.js";
import type { RivalInsight } from "../../../shared/presentation/rival-insight.js";

export interface ClubhouseSections {
  loading: boolean;
  error: string | null;
  rivals: RivalListItem[];
  rounds: RoundListItem[];
  featured: ComparisonDetail | null;
  finding: RivalInsight | null;
  findings?: RivalInsight[];
  insightLoading: boolean;
}

/** Optional insights must never hold the rival list or next-round action hostage. */
export async function loadClubhouseSections(deps: {
  rivals(): Promise<ProductPagePayload>;
  rounds(): Promise<ProductPagePayload>;
  insight(): Promise<{
    finding: RivalInsight;
    findings?: RivalInsight[];
    detail: ComparisonDetail;
  } | null>;
  publish(patch: Partial<ClubhouseSections>): void;
}): Promise<void> {
  await Promise.all([
    deps.rivals().then(
      (rivals) =>
        deps.publish({
          loading: false,
          rivals: rivals.page === "rivals" ? rivals.data.rivals : [],
        }),
      () =>
        deps.publish({
          loading: false,
          error: "Your rivals could not load. Try again.",
        }),
    ),
    deps.rounds().then(
      (rounds) =>
        deps.publish({
          rounds: rounds.page === "stats" ? rounds.data.rounds : [],
        }),
      () => undefined,
    ),
    deps.insight().then(
      (insight) =>
        deps.publish({
          featured: insight?.detail ?? null,
          finding: insight?.finding ?? null,
          findings:
            insight?.findings ?? (insight?.finding ? [insight.finding] : []),
          insightLoading: false,
        }),
      () => deps.publish({ insightLoading: false }),
    ),
  ]);
}
